import colors from '../../../../../public/colors'


const styles = theme => {
    const { mode } = theme.palette
    return {
        actionRow: {
            '& > button': {
                marginLeft: 'auto'
            },
            justifyContent: 'flex-end',
            height: '100%'
        },
        button: {
            '&.MuiButton-root': {
                border: '1px solid #006AC3',
                borderRadius: '4px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                height: '40px',
                marginLeft: '10px',
                width: '104px'
            }
        },
        buttonContainer: {
            '@media screen and (max-width: 320px)': {
                paddingBottom: '20px'
            },
            backgroundColor: colors[mode].primaryBackground,
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '16px 24px'
        },
        buttonSubmit: {
            '&.MuiButton-root': {
                backgroundColor: '#FEDF01',
                border: '1px solid #FEDF01',
                borderRadius: '2px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                color: '#003168',
                fontFamily: 'Roboto',
                fontFeatureSettings: '"liga" off, "clig" off',
                fontSize: '12px',
                fontWeight: 400,
                height: '32px',
                letterSpacing: '0.46px',
                lineHeight: '16px',
                marginLeft: '10px',
                padding: '8px 16px',
                textTransform: 'uppercase',
            },
            '&:disabled': {
                borderColor: 'rgba(0, 0, 0, 0.12)',
                opacity: '0.5'
            }
        },
        checkCircle: {
            height: '32px',
            width: '32px'
        },
        content: {
            color: '#0267FF',
            fontSize: '24px',
            fontWeight: '500'
        },
        contentContainer: {
            backgroundColor: 'white',
            borderRadius: '3px',
            boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
            color: 'black'
        },
        contentDivider: {
            paddingTop: '25px'
        },
        contentSection: {
            color: 'black',
            fontSize: '20px'
        },
        divider: {
            background: '#FFC72A',
            padding: '2px',
            width: '50px'
        },
        fieldsContainer: {
            backgroundColor: colors[mode].primaryBackground,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'flex-start',
            minHeight: '250px',
            padding: '16px 24px',
        },
        loader: {
            height: '100%',
            left: '0',
            position: 'absolute',
            top: '0',
            width: '100%',
            'z-index': '10'
        },
        mfaDesc: {
            color: colors[mode].secondaryText,
            fontSize: '14px'
        },
        mfaIconBox: {
            flexDirection: 'row',
            alignItems: 'center',
            display: 'flex',
            marginBottom: '8px'
        },
        mfaListContainer: {
            paddingTop: '20px'
        },
        mfaLogo: {
            height: '20px',
            width: '20px'
        },
        mfaLogoContainer: {
            alignItems: 'flex-start',
            display: 'flex'
        },
        mfaNameContainer: {
            flexDirection: 'column',
        },
        mfaOption: {
            '&:hover': {
                cursor: 'pointer',
                opacity: 0.9
            },
            alignItems: 'center',
            border: `1px solid ${colors[mode].recoveryBorder}`,
            borderRadius: '2px',
            display: 'flex',
            flexDirection: 'row',
            fontFamily: 'Roboto',
            justifyContent: 'space-between',
            marginBottom: '16px',
            padding: '12px 12px',
            width: '90%'
        },
        mfaOptionSelected: {
            backgroundColor: colors[mode].skeletonInsightsBackground,
            border: `1px solid ${colors[mode].recoveryBorder}`,
            color: '#003168',
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '24px',
        },
        mfaSetupTitle: {
            color: 'rgba(0,0,0,0.87)',
            fontSize: '16px',
            height: '24px',
            letterSpacing: '0',
            lineHeight: '24px',
            paddingTop: '20px',
            marginBottom: '20px'
        },
        mfaTitle: {
            color: colors[mode].primaryText,
            fontFeatureSettings: '"liga" off, "clig" off',
            fontFamily: 'Roboto',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '24px',
            marginLeft: '8px'
        },
        mfaTitleDesc: {
            minHeight: '76px'
        },
        radio: {
            '&.Mui-checked': {
                color: colors[mode].recoveryIcon
            },
            color: colors[mode].primaryText,
        },
        warningLine: {
            background: colors[mode].primaryBackground,
            color: colors[mode].secondaryText,
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '14px',
            fontStyle: 'italic',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            padding: '0px 0px 24px 32px'
        }
    }
}
export default styles
